var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('van-nav-bar',{attrs:{"title":"禁忌表","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_vm._v(" "),_c('div',{staticClass:"image"},[_c('van-image',{attrs:{"width":"100%","height":"550","src":"https://static.idburg.cn/hqdx/d99592d2fc6db521bf274916910cfa62eece878250db769992a25fdf92ea05e2.png"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49dfb878","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabooInfo.vue
// module id = null
// module chunks = 